import {useMutation, useQueryClient} from '@tanstack/react-query';

import {updateBasketballLeagueQuarterMinutes} from '../api';
import {QUERY__BASKETBALL_LEAGUES} from './useGetBasketballLeagues';

export const useUpdateBasketballLeagueQuarterMinutes = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateBasketballLeagueQuarterMinutes,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__BASKETBALL_LEAGUES],
      });
    },
  });
};
